module.exports = __webpack_public_path__ + "mx.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mx.svg
// module id = 970
// module chunks = 0